import React from "react";
import {Typography} from "antd";
import diagram from '../../../images/item-comparison-overview.svg';

export const ComparableHelp: React.FC = () => {
  return (
    <>
      <Typography.Paragraph>
        This interface allows users to compare stars and signals to each other
        to determine differences.
      </Typography.Paragraph>
      <Typography.Paragraph>
        Some quick definitions:
        <table border={1}>
          <thead>
            <td>Name</td>
            <td>Definition</td>
          </thead>
          <tbody>
            <tr>
              <td>Assigned Atlas</td>
              <td>
                If this item is a delivery, compare to its assigned atlas.
                Otherwise if the item is an Atlas, this field will not be
                populated.
              </td>
            </tr>
            <tr>
              <td>
                Siblings
              </td>
              <td>
                Applicable to Signals only. Signals are considered siblings
                when they have the same host star.
              </td>
            </tr>
            <tr>
              <td>
                Delivery Siblings
              </td>
              <td>
                Applicable to Delivered Signals only. Signals are considered
                related when signals are matched any host star under the same
                atlas.
              </td>
            </tr>
            <tr>
              <td>
                Sources
              </td>
              <td>
                Applicable to Atlases only. Items are considered sources if
                their atlas field is this item.
              </td>
            </tr>
          </tbody>
        </table>
      </Typography.Paragraph>
      <Typography.Title level={5}>Sibling Diagam</Typography.Title>
      <img src={diagram} style={{width: "100%"}} />
    </>
  );
};
